import { CHANGE_SCREEN_TYPE } from "@common/constants/action-types";
export var changeScreenType = function(state) {
    return function(dispatch) {
        dispatch({
            type: CHANGE_SCREEN_TYPE,
            payload: state
        });
    };
};
